import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-narrow-right', 'ArrowNarrowRight', [["path",{"d":"M5 12l14 0"}],["path",{"d":"M15 16l4 -4"}],["path",{"d":"M15 8l4 4"}]]);